import { StyledInteractiveVideoPlayer } from './InteractiveVideoPlayer.styled';
import useInteractiveVideoPlayer from './useInteractiveVideoPlayer.hook';
import VideoPlayer from '@/shared/Players/VideoPlayer/VideoPlayer';
import InteractiveVideoSummary from './InteractiveVideoSummary/InteractiveVideoSummary';
import AudioAutoPlayer from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayer';
import AudioQuestionModal from './AudioQuestion/AudioQuestionModal';
import AnimatedStars from '@/shared/StudentPage/StudentPageTopbar/GamificationScoreBoard/AnimatedStars/AnimatedStars';
import { ANCHOR } from '@/modules/dom/getElementCoordinates';

export default function InteractiveVideoPlayer({
  videoUrls,
  poster,
  questions,
  forceRestart,
  activityName,
  onVideoTimeChange,
  activityActions,
  noSeek = true,
}) {
  const { state, actions } = useInteractiveVideoPlayer({
    questions,
    forceRestart,
    activityActions,
    noSeek,
    onVideoTimeChange,
  });

  return (
    <>
      <StyledInteractiveVideoPlayer>
        <AnimatedStars
          originSelector=".correct.selected"
          originAnchor={ANCHOR.RIGHT}
        />
        <VideoPlayer
          urls={videoUrls}
          posterUrl={poster}
          onStart={actions.shared.onStart}
          onPlay={actions.shared.onPlay}
          onProgress={actions.shared.onProgress}
          playing={
            state.started && !state.currentQuestion && !state.showSummary
          }
          progressInterval={100}
          cues={state.questions}
          onCue={actions.shared.onQuestionCue}
          currentCue={state.currentQuestion}
          showCues
          pauseOnCue
          noSeek={state.noSeek}
          canPlay={!state.currentQuestion}
          forceRestart={forceRestart}
          onRestart={actions.shared.onRestart}
          customFullscreen={{
            onFullScreen: actions.shared.onFullScreen,
            isFullscreen: state.isFullscreen,
          }}
          canIncreasePlaybackRate={!activityActions}
          onSeek={actions.shared.onSeek}
        >
          {state.currentQuestion ? (
            <AudioQuestionModal
              question={state.currentQuestion}
              questionsProgress={`Question ${state.currentQuestion.id + 1} of ${
                state.questions.length
              }`}
              questionActions={{
                onAnswer: actions.shared.onQuestionAnswer,
                onContinue: actions.shared.onContinue,
              }}
            ></AudioQuestionModal>
          ) : null}
          {state.showSummary ? (
            <InteractiveVideoSummary
              activityName={activityName}
              questions={state.questions}
              answeredQuestions={state.answeredQuestions}
              onContinue={actions.shared.onContinue}
              onRestart={actions.shared.onRestart}
              canRestart={!activityActions}
            />
          ) : null}
        </VideoPlayer>
        <AudioAutoPlayer />
      </StyledInteractiveVideoPlayer>
    </>
  );
}
